import { render, staticRenderFns } from "./DeliveryFormSection.vue?vue&type=template&id=a92bd0b6&scoped=true&"
import script from "./DeliveryFormSection.vue?vue&type=script&lang=js&"
export * from "./DeliveryFormSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92bd0b6",
  null
  
)

export default component.exports